export class InitApp {
  static readonly type = '[app] initialize application';
}

export class SetUser {
  static readonly type = '[app] set user';
}

export class GetCourses {
  static readonly type = '[app] get courses';
}

export class GetStrengthsAndOpportunitiesReport {
  static readonly type = '[app] GetStrengthsAndOpportunitiesReport';
  constructor(public payload: { postingUUID: string }) {}
}

export class Logout {
  static readonly type = '[Auth] Logout';
}

export class GetTimezones {
  static readonly type = '[app] get timezones';
}

export class GetCurrentUser {
  static readonly type = '[app] get current user';
}

export class CheckOldPassword {
  static readonly type = '[app] check old password';
  constructor(public payload: { oldPassword: string }) {}
}

export class UpdateStudentProfile {
  static readonly type = '[app] update student profile';
  constructor(public payload: { formData: FormData; studentId: number }) {}
}

export class AcceptEULA {
  static readonly type = '[assessments] accept eula';
  constructor(public payload: { language: string }) {}
}

export class SwitchProfile {
  static readonly type = '[app] switch profile';
}
